import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WithdrawalInstruction } from '../../../../../../models/submissions/withdrawal-instruction';
import { TrackByUtils } from '../../../../../../utils/track-by-utils';

@Component({
  selector: 'app-vb-payment-change-withdrawal-instructions',
  templateUrl: './vb-payment-change-withdrawal-instructions.component.html',
  styleUrls: ['./vb-payment-change-withdrawal-instructions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeWithdrawalInstructionsComponent {
  @Input({ required: true }) withdrawalInstructions!: WithdrawalInstruction[];

  protected readonly trackByIndex = TrackByUtils.trackByIndex;
}
